<template>
  <b-col cols="12">
    <b-table
      hover
      no-local-sorting
      :fields="fields"
      :items="data"
      :busy="busy"
      @sort-changed="onSortingChanged"
    >
      <template #cell(name)="row">
        <router-link :to="`/items/${row.item.id}`">
          {{ row.item.name }}
        </router-link>
      </template>
      <template #cell(price)="row">
        {{ (row.item.price / 100) | currency }}
      </template>
      <template #cell(status)="row">
        {{ row.item.status | capitalize }}
      </template>
    </b-table>
    <b-pagination
      v-if="rows > perPage"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
      @input="onPaginate"
    ></b-pagination>
  </b-col>
</template>

<script>
import ResourceAPI from '../../services/ResourceAPI';

export default {
  name: 'Items',

  props: {
    modifierId: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      fields: [
        {
          key: 'blank',
          label: '',
          thStyle: { width: '5%' },
        },
        {
          key: 'name',
          label: 'Items On',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          thStyle: { width: '18%' },
        },
        {
          key: 'price',
          label: 'Price',
          sortable: true,
          thStyle: { width: '13%' },
        },
      ],
      data: [],
      currentPage: 1,
      perPage: 25,
      rows: 0,
      sort: '',
      dir: '',
      search: '',
      busy: true,
    };
  },

  watch: {
    modifierId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.onPaginate(1);
        }
      },
    },
  },

  methods: {
    onPaginate(page) {
      this.currentPage = page;
      this.loadResults();
    },

    onSortingChanged(ctx) {
      this.sort = ctx.sortBy;
      this.dir = ctx.sortDesc ? 'DESC' : 'ASC';
      this.loadResults();
    },

    loadResults() {
      const me = this;

      me.busy = true;

      return ResourceAPI.getRecords('items', {
        limit: me.perPage,
        page: me.currentPage,
        sort: me.sort,
        dir: me.dir,
        attribute: me.modifierId,
      })
        .then((data) => {
          me.rows = data.total;
          me.data = data.data;
          me.busy = false;
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>
